import type { RouteRecordRaw } from 'vue-router'
import { VideoPlayIcon } from '@/components/icons'

export const CourseRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'courses',
    alias: '/courses',
    redirect: '/courses',
    meta: { middleware: 'auth', requiresAuth: true },
    component: () => import('@/layouts/dashboard-layout/index.vue'),
    children: [
      {
        path: '/courses',
        name: 'course-list',
        component: () => import('@/views/course-lessons/courses/index.vue'),
        meta: {
          breadcrumb: [{ text: 'دوره ها', to: '/', icon: VideoPlayIcon }]
        }
      },
      {
        path: '/courses/:course_id',
        name: 'course_detail',
        component: () => import('@/views/course-lessons/courses/course/index.vue'),
        props: (route) => ({ course_id: route.params.course_id })
      },
      {
        path: '/courses/:course_id/roadmap',
        name: 'course_roadmap',
        component: () => import('@/views/course-lessons/roadmap/index.vue')
      },
      {
        path: '/courses/:course_id/leaderboard',
        name: 'course_leaderboard',
        component: () => import('@/views/course-lessons/leaderboard/index.vue'),
        meta: {
          breadcrumb: [{ text: 'لیدربورد', to: '/', icon: VideoPlayIcon }]
        }
      },
      {
        path: 'lessons/:courseId/discussion/:sectionId',
        name: 'course_discussion',
        component: () => import('@/views/course-lessons/discussions.vue')
      }
    ]
  }
]
